import defs from '../_core/defs.js';
// returns an array which contains things like [key, value]
export default function keys() {
  var def = defs.get(this);
  /* istanbul ignore if */
  if (!def) {
    return [];
  }
  var keysArr = Object.keys(def.keys);
  var length = keysArr.length;
  var result = new Array(length);
  for (var i = 0; i < keysArr.length; i++) {
    var key = keysArr[i];
    result[i] = [key, this[key]];
  }
  return result;
}